// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { headerLinkListStyles } from "@steiner/Overrides/Widgets/Header/HeaderLinkList";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const separateLineStyle = css`
    position: relative;
    padding-left: 24px;
    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 1px;
        background: ${color("common.border")};
    }
`;

headerLinkListStyles.container = {
    css: css`
        display: flex;
        gap: 24px;
        padding: 0 0 0 30px;
    `,
};

headerLinkListStyles.itemWrapper = {
    css: css`
        display: inline-flex;
        position: relative;
    `,
};

headerLinkListStyles.headerLinkListWrapper = {
    css: css`
        display: flex;
        gap: 24px;
        align-items: center;

        &.separate-line {
            ${separateLineStyle}
        }

        & > .RootMenu[aria-expanded="true"] > .list-link,
        & > .item-wrapper > .cascading-menu[aria-expanded="true"] > .list-link {
            & > ${TypographyStyle}, & > ${TypographyStyle} ${IconWrapper} {
                color: ${color("common.ui9")}
            }

            & > ${TypographyStyle} ${IconWrapper} {
                transform: rotate(180deg);
            }
        }
        
        /* Keep link active and arrow rotated when hovering on dropdown items */
        & > .RootMenu:hover > .list-link,
        & > .item-wrapper > .cascading-menu:hover > .list-link {
            & > ${TypographyStyle}, & > ${IconWrapper} {
                color: ${color("common.ui9")};
            }

            & > ${IconWrapper} {
                transform: rotate(180deg);
            }
        }
    `,
};

headerLinkListStyles.link = {
    color: "common.white",
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.semiBold,
        lineHeight: "22px",
    },
    css: css`
        flex-shrink: 0;
        ${IconWrapper} {
            color: ${color("common.white")};
            margin-left: 4px;
            transition: transform 0.2s ease;
        }
        &:hover ${IconWrapper} {
            color: ${color("common.ui8")};
        }
    `,
};

headerLinkListStyles.firstNameWrapper = {
    css: css`
        display: flex;
        align-items: center;

        &.separate-line {
            ${separateLineStyle}
        }
    `,
};

headerLinkListStyles.firstName = {
    size: 14,
    color: "secondary",
    weight: fontConfig.weight.semiBold,
    lineHeight: "22px",
    css: css`
        text-transform: capitalize;
        max-width: 140px;
        ${ellipsis(1)}
    `,
};

headerLinkListStyles.cascadingMenu = {
    cssOverrides: {
        menu: css`
            width: 320px;
            margin-top: 0;
        `,
    },
};